import { store, useAppDispatch } from "@store";
import { openDialog } from "@store/dialogs";
import { getSlideWithEntities } from "@store/story/selectors";
import { useCallback } from "react";
import { invertFlatData } from "@/shared";
import { SlideSaveDialog } from "../dialogs";

export const useSaveToSlides = (id: string) => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    const state = store.getState();
    const wholeEntity = getSlideWithEntities(id)(state);
    if (!wholeEntity) return;

    const { root: entityRoot, entities } = wholeEntity;
    if (!entityRoot || !entities) return;

    const slide = invertFlatData({
      flatData: {
        root: {
          type: "root",
          id: "root",
          settings: {},
          parentId: null,
          childIds: [entityRoot],
        },
        ...entities,
      },
    })[0];

    dispatch(
      openDialog({
        id: "save-to-my-slides",
        content: SlideSaveDialog,
        props: { slide },
      }),
    );
  }, [dispatch, id]);
};
